import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CameraLogin from "./pages/Cameras/CameraLogin";
import CameraPortal from "./pages/Cameras/CameraPortal";
import { CameraProtectedRoute } from "./pages/Cameras/CameraProtectedRoute";
import TermsGate from "./pages/Cameras/components/TermsGate";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

function LocalhostBanner() {
  React.useEffect(() => {
    if (!isLocalhost) return;
    const link: HTMLLinkElement =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg+xml";
    link.href =
      "data:image/svg+xml," +
      encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="%23f59e0b"/><text x="50" y="68" text-anchor="middle" font-size="50" font-weight="bold" fill="white">C</text></svg>'
      );
    document.head.appendChild(link);
    document.title = "[DEV] Wip Cams";
  }, []);

  if (!isLocalhost) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "#f59e0b",
        color: "#000",
        textAlign: "center",
        padding: "2px 0",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "1px",
      }}
    >
      LOCALHOST — AMBIENTE DE DESENVOLVIMENTO
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LocalhostBanner />
      <div className="App" style={isLocalhost ? { paddingTop: "22px" } : undefined}>
        <Routes>
          <Route path="/Cameras/Login" element={<CameraLogin />} />
          <Route
            path="/Cameras/Portal"
            element={
              <CameraProtectedRoute>
                {/* Sem o aceite do termo o portal nem chega a carregar. */}
                <TermsGate>
                  <CameraPortal />
                </TermsGate>
              </CameraProtectedRoute>
            }
          />
          {/* Tudo o mais cai no login do cliente. */}
          <Route path="*" element={<Navigate to="/Cameras/Login" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
